import { makeObservable, observable } from 'mobx';

import { ReferralList } from '@dashboard/ui/pages/ReferralPage/store/models/ReferralList';

export class ReferralPageStore {
    public static Name = 'referralPageStore' as const;

    @observable public myReferralList = new ReferralList();
    @observable public assignedToMeReferralList = new ReferralList();
    @observable public referralsList = new ReferralList();

    constructor() {
        makeObservable(this);
    }
}

export const referralPageStore = new ReferralPageStore();
